// extracted by mini-css-extract-plugin
export default {"PresetsDropdown":"OfferSchedulePresetsDropdown_PresetsDropdown__0c8q8"};